export default {
  Mobile: "Mobile",
  PC: "PC"
};
